import './App.css';
import ColorPicker from './components/ColorPicker';
import colors from './colors.json';
import ImageUploadComponent from './components/ImageUploadComponent';
import { AiOutlineRobot } from 'react-icons/ai';
import InfoComponent from './components/InfoComponent';
import { useState } from 'react';
import axios from 'axios';
import SuggestedColors from './components/SuggestedColors';
import FAQ from './components/FAQ';
import GreenShadePicker from './components/GreenShadePicker';

const contentDataList = window.content_data;
// const contentDataList = {
//   "content": [
//     {
//       "color": "neon blue",
//       "suggested_colors": [
//         { "color": "ruby", "link": "https://wordlab.io/ruby-background" },
//         { "color": "scarlet", "link": "https://wordlab.io/scarlet-background" },
//         { "color": "wine", "link": "https://wordlab.io/wine-background" }
//       ],
//       "values": [
//         {
//           "position": 0,
//           "rgba": "226, 250, 254, 255"
//         },
//         {
//           "position": 1,
//           "rgba": "177, 243, 254, 255"
//         },
//         {
//           "position": 2,
//           "rgba": "128, 235, 255, 255"
//         },
//         {
//           "position": 3,
//           "rgba": "79, 228, 255, 255"
//         },
//         {
//           "position": 4,
//           "rgba": "30, 221, 255, 255"
//         },
//         {
//           "position": 5,
//           "rgba": "0, 200, 236, 255"
//         },
//         {
//           "position": 6,
//           "rgba": "0, 159, 187, 255"
//         },
//         {
//           "position": 7,
//           "rgba": "0, 117, 138, 255"
//         },
//         {
//           "position": 8,
//           "rgba": "0, 76, 89, 255"
//         },
//         {
//           "position": 9,
//           "rgba": "0, 34, 40, 255"
//         }
//       ]
//     }

//   ]
// }

function App() {

  const contentData = contentDataList.content
  const mainColor = contentData[0].color;
  const colorValues = contentData[0].values
  const suggestedColors = contentData[0].suggested_colors

  const [selectedImage, setSelectedImage] = useState(null)
  const [convertedImage, setConvertedImage] = useState(null)
  const [selectedColor, setSelectedColor] = useState(colorValues[0].rgba)
  const [isLoading, setIsLoading] = useState(false)
  const [activeTab, setActiveTab] = useState('Before');

  const reset = () => {
    setSelectedImage(null);
    setConvertedImage(null);
  };

  function downloadImage() {
    const element = document.createElement('a');
    element.href = convertedImage;
    element.download = "wordlab-io-result";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  const handleColorSelection = (selectedRgba) => {
    setSelectedColor(selectedRgba)
  };

  const onFileSelected = (base64) => {
    setSelectedImage(base64)
  }

  const changeBackground = async () => {
    try {
      setIsLoading(true)
      const result = removeBase64Prefix(selectedImage)
      const body = {
        image: result,
        bgColor: selectedColor
      }

      // const response = await axios.post('http://localhost:4000/change-background/', body);
      const response = await axios.post('https://wordlab.nw.r.appspot.com/change-background/', body);

      setConvertedImage(`data:image/png;base64,${response.data.image}`)
      setIsLoading(false)

    } catch (error) {
      setIsLoading(false)
    }
  }

  function removeBase64Prefix(base64Data) {
    const parts = base64Data.split(",");
    return parts.length > 1 ? parts[1] : parts[0];
  }

  function hexToRgba(hex) {
    if (hex.length === 4) {
      hex = '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
    }

    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `${r}, ${g}, ${b}, 255`;
  }

  const hexColors = [
    "#e2fafe",
    "#b1f3fe",
    "#80ebff",
    "#4fe4ff",
    "#1eddff",
    "#00c8ec",
    "#009fbb",
    "#00758a",
    "#004c59",
    "#002228"
  ];

  const convertedColors = {
    "color": "neon blue",
    "values": hexColors.map((color, index) => {
      return {
        "position": index,
        "rgba": hexToRgba(color)
      }
    })
  };

  // console.log(JSON.stringify(convertedColors, null, 2));

  return (
    <div className='h-full mt-20'>
      <div className='w-full flex justify-center my-6'>
        <div className='flex flex-col justify-center items-center  w-full md:w-1/2'>
          <h1 className='font-inter font-bold text-3xl text-center text-slate-800 capitalize'>Transform Your Photos With A {mainColor} Background!</h1>
          <h2 className='font-inter font-semibold text-xl text-center text-slate-800 my-4'>Discover the magic of our tool and change your image to feature a stunning {mainColor} background, instantly.</h2>
        </div>
      </div>
      {convertedImage ? (
        <div className="flex justify-center my-10">
          <div className="w-full md:w-1/2">
            <div className="flex justify-center mb-4 font-inter cursor-pointer">
              <div
                className={`px-4 py-2 rounded-lg ${activeTab === 'Before' ? 'bg-gray-300' : ''}`}
                onClick={() => setActiveTab('Before')}
              >
                Before
              </div>
              <div
                className={`px-4 py-2 rounded-lg ${activeTab === 'After' ? 'bg-gray-300' : ''}`}
                onClick={() => setActiveTab('After')}
              >
                After
              </div>
            </div>
            <div className="flex flex-col justify-center items-center md:items-start">
              <img
                src={activeTab === 'Before' ? selectedImage : convertedImage}
                alt={activeTab === 'Before' ? 'Original Image' : 'Converted Image'}
                className="max-w-1/2 h-80 mx-auto object-contain"
              />
            </div>
            <div className="flex justify-center mt-4">
              <button className="mr-2 px-4 py-2 border border-crayola-800 text-crayola-800  hover:bg-gradient-to-r hover:from-gray-50 hover:to-gray-100 rounded-md" onClick={reset}>
                Start Again
              </button>
              <button className='px-4 py-2 bg-gradient-to-r border border-crayola-800 from-crayola-700 to-crayola-800 hover:bg-gradient-to-r hover:from-crayola-800 hover:to-crayola-900 text-white rounded-md outline-none' onClick={downloadImage}>
                Download
              </button>
            </div>
          </div>
        </div>) : (<>
          <ImageUploadComponent onFileSelected={onFileSelected} />
          <ColorPicker colorData={colorValues} currentColor={mainColor} onSelect={handleColorSelection} />
          <div className='flex-col text-center h-'>
            <div className='flex justify-center items-center'>
              <button onClick={(e) => changeBackground(e)} className='w-full md:w-1/4 mx-4 md:mx-0 my-4 md:mt-4 flex justify-center bg-gradient-to-r border border-crayola-800 from-crayola-700 to-crayola-800 hover:bg-gradient-to-r hover:from-crayola-800 hover:to-crayola-900 text-white rounded-md outline-none py-1 mt-4' disabled={isLoading}>
                {isLoading ?
                  <div className='flex justify-center items-center'>
                    <svg className="h-8 w-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span className="font-medium ml-2">Changing...please wait </span>
                  </div>
                  :
                  <div className="flex justify-center items-center font-inter"><AiOutlineRobot
                    className='h-8 w-5 mr-2'
                  />Change background color</div>}
              </button>
            </div>
            <p className=' text-sm text-gray-400'>( Max size for a image is 5 MB )</p>
          </div>
        </>
      )}


      <div className='border-2 border-crayola-500 md:mx-28 my-10' />
      <InfoComponent />
      <div className='border-2 border-crayola-500 md:mx-28 my-10' />
      <SuggestedColors data={suggestedColors} />
      <div className='border-2 border-crayola-500 md:mx-28 my-10' />
      <FAQ />
    </div>
  )
}

export default App;

